import jwtDecode from 'jwt-decode'

const initialState = {
   currentUser:{
       name:localStorage.getItem('user'), 
       userId:localStorage.getItem('userId'), 
       firstName:localStorage.getItem('firstName'), 
       email:localStorage.getItem('userEmail'), 
       email2:localStorage.getItem('userEmail2'),
       isAvailable: localStorage.getItem('isAvailable') === null ? true : localStorage.getItem('isAvailable') === 'true'
   },
    currentCompany: {name:localStorage.getItem('companyName'),isParentCompany:localStorage.getItem('isParentCompany')==='True', id:localStorage.getItem('companyId'),mateId:localStorage.getItem('companyMateId'), token:localStorage.getItem('companyName'), logo:localStorage.getItem('companyLogo'), childCompanies:JSON.parse(localStorage.getItem('childCompanies'))}
};


export default (previousState = initialState, { type, payload }) => {
    if (type === 'COMPANY_SELECTED') {
        console.log('company',payload)
        localStorage.setItem('company',payload.token);
        // localStorage.setItem('isParentCompany',payload.isParentCompany);
        localStorage.setItem('companyId',payload.id);
        localStorage.setItem('companyMateId',payload.mateId);
        localStorage.setItem('companyLogo',payload.logo);
        localStorage.setItem('childCompanies',payload.childCompanies?JSON.stringify(payload.childCompanies):'[]');
        const decoded = jwtDecode(payload.token);
        localStorage.setItem('companyName',decoded['RegisteredName']);
        localStorage.setItem('isParentCompany',decoded['isParentCompany']);
        if (payload.apiKeys && payload.apiKeys.length > 0) {
            const tikKey = payload.apiKeys.find(k => k.name === 'tik');
            if (tikKey) {
                localStorage.setItem('tik_api_key', tikKey.key);
            }
        }
        payload.name = decoded['RegisteredName'];
        payload.isParentCompany = decoded['isParentCompany']==='True';
         return {...previousState, currentCompany: payload};
    }
    if (type === 'USER_LOADED') {
       //console.log('user',payload)
       // console.log(payload)
    //    console.log('user',payload)
        localStorage.setItem('user',payload.username)
        localStorage.setItem('userId',payload.id)
        localStorage.setItem('firstName',payload.firstName)
        localStorage.setItem('userEmail',payload.email)
        payload.email2&&localStorage.setItem('userEmail2',payload.email2)
  
            localStorage.setItem('isAvailable', payload.IsAvailable);

        
        return {...previousState, currentUser: {...payload, isAvailable: typeof payload.isAvailable !== 'undefined' ? payload.isAvailable : (previousState.currentUser.isAvailable !== undefined ? previousState.currentUser.isAvailable : true)}};
    }
    if (type === 'USER_AVAILABILITY_UPDATED') {
        localStorage.setItem('isAvailable', payload.isAvailable);
        return {
            ...previousState,
            currentUser: {
                ...previousState.currentUser,
                isAvailable: payload.isAvailable
            }
        };
    }
    return previousState;
}
